<template>
  <v-main>
    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        :to="($i18n.locale == 'en') ? '/en' : '/'"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>できること・使い方</v-toolbar-title>

    </v-app-bar>

    <v-container mt-12 py-6 px-6>
      <h2 class="title font-weight-bold">バックアップとインポート</h2>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップデータのバックアップをとる</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-download</v-icon>をクリックしてください。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップデータをインポートする</h3>
      <p class="body-2">「ポジショニングマップ」画面右上の<v-icon color="primary">mdi-database-import</v-icon>をクリックし、バックアップデータを選択してください。</p>

      <v-divider
        class="py-4"
      ></v-divider>

      <h2 class="title font-weight-bold">基本編</h2>
      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップを作成する</h3>
      <p class="body-2">「ポジショニングマップ」画面の下部フォームにタイトルを入力して
        <v-btn
          depressed
          color="primary"
          small
        >{{ $t('List.createButton') }}
        </v-btn>
      をクリックすると、一覧にポジショニングマップが追加されます。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップを開く</h3>
      <p class="body-2">「ポジショニングマップ」画面から開きたいポジショニングマップタイトルをクリックしてください。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップをコピーする</h3>
      <p class="body-2">「ポジショニングマップ」画面からコピーしたいポジショニングマップタイトルの<v-icon color="primary">mdi-plus</v-icon>をクリックすると、一覧にポジショニングマップが追加されます。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップの軸の名前を決める</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cog</v-icon>をクリックし、軸の名前を登録してください。</p>

      <h3 class="subtitle-1 font-weight-bold">Object（円の図形）を追加する</h3>
      <p class="body-2">画面上の任意の場所をクリックしてください。</p>

      <h3 class="subtitle-1 font-weight-bold">Object（円の図形）を更新する</h3>
      <p class="body-2">Objectをクリックし必要項目を入力してください。</p>

      <h3 class="subtitle-1 font-weight-bold">Object（円の図形）を削除する</h3>
      <p class="body-2">Objectをクリックし
        <v-btn
          color="red"
          dark
          depressed
          small
        >
          {{ $t('Workspace.object.deleteButton') }}
        </v-btn>
      をクリックしてください。</p>

      <h3 class="subtitle-1 font-weight-bold">Object（円の図形）を移動する</h3>
      <p class="body-2">Objectをドラッグしてください。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップのタイトルを変更する</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cog</v-icon>をクリックし、Titleを変更してください。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップを削除する</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cog</v-icon>をクリックし、
        <v-btn
          color="red"
          dark
          depressed
          small
        >
          {{ $t('Workspace.setting.deleteButton') }}
        </v-btn>
      をクリックしてください。</p>

      <v-divider
        class="py-4"
      ></v-divider>

      <h2 class="title font-weight-bold">応用編</h2>

      <h3 class="subtitle-1 font-weight-bold">Object（円の図形）の大きさを変える</h3>
      <p class="body-2">ObjectをクリックしSizeを変更してください。色や線の太さも変えることができます。</p>

      <h3 class="subtitle-1 font-weight-bold">ObjectのNameとMarkの表示場所を入れ替える</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cog</v-icon>をクリックし、Name-Markを切り替えてください。</p>

      <h3 class="subtitle-1 font-weight-bold">Objectへのマウスオーバーで、Noteを表示/非表示する（PCのみ）</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cog</v-icon>をクリックし、Note表示を切り替えてください。</p>

      <h3 class="subtitle-1 font-weight-bold">ポジショニングマップを公開する（休止中）</h3>
      <p class="body-2">画面右上の<v-icon color="primary">mdi-cloud-upload</v-icon>をクリックし、注意事項を確認の上、限定公開URLを取得、ご利用者様自身で公開するなどしてください。</p>
    </v-container>
  </v-main>
</template>

<script>
export default {
  metaInfo: {
    title: 'できること・使い方',
    meta: [
      { name: 'description', content: 'ポジショニングマップ.COMで、できること、使い方の説明です。' }
    ]
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
h3 {
  margin-top: 20px;
}
p {
  margin-top: 4px;
}
</style>
